<template>
    <div class="modal fixed" :class="{'is-active': isActive}" v-if="isActive">
        <div class="modal-background" @click.prevent="$emit('close')"></div>
        <div class="modal-content">
            <div class="modal-card">
                <header class="modal-card-head bg-purple">
                    <p class="modal-card-title text-purple-100 text-white">
                        <slot name="header"></slot>
                    </p>
                    <button class="delete" @click.prevent="$emit('close')"></button>
                </header>
                <section class="modal-card-body" :class="bodyClass">
                    <slot></slot>
                </section>
                <footer class="modal-card-foot flex-row-reverse">
                    <slot name="footer"></slot>
                    &nbsp;<a class="button is-300" @click.prevent="$emit('close')">ยกเลิก</a>
                </footer>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        props: {
            isActive: {'default': false},
            bodyClass: {'default': null},
        },
    }
</script>